import axios from '@/axios';

export default {
    fetchAccountLevels() {
        return axios.get('/api/v1/admins/account-levels');
    },
    createAccountLevel(_context, data) {
        return axios.post('/api/v1/admins/account-levels/create', data);
    },
    updateAccountLevel(_context, data) {
        return axios.patch(`/api/v1/admins/account-levels/update/${data._id}`, data);
    },
    deleteAccountLevel(_context, { _id }) {
        return axios.delete(`/api/v1/admins/account-levels/delete/${_id}`);
    },
};
